import {
  API_ENDPOINT_ADD_IDP_PROJECT,
  API_ENDPOINT_CREATE_EXISTING_IDP_EVAL_WITH_FILE,
  API_ENDPOINT_CREATE_NEW_EVAL,
  BASE_URL,
  BASE_URL_EVAL,
  CONTENT_TYPES,
} from "./constants";
import { isValid, isBefore } from 'date-fns';

/**
 * Get the content type
 * @param {
 *      requestUrl : {Type : string}
 *      contentType : {Type : string}  
 * }  
 * @returns 
 */
export const getContentType = (
  requestUrl,
  contentType = CONTENT_TYPES?.APPLICATION_JSON
) => {
  if (!requestUrl) return;

  const formDataUrls = [
    BASE_URL + API_ENDPOINT_ADD_IDP_PROJECT,
    BASE_URL_EVAL + API_ENDPOINT_CREATE_NEW_EVAL,
    // BASE_URL_EVAL + API_ENDPOINT_CREATE_EXISTING_IDP_EVAL,
    BASE_URL_EVAL + API_ENDPOINT_CREATE_EXISTING_IDP_EVAL_WITH_FILE,
  ];
  const separator = "";
  const separatorQueryString = "?";

  let searchString = stringToSearch(requestUrl, separator, false);

  if (searchString.includes(separatorQueryString)) {
    searchString = stringToSearch(searchString, separatorQueryString, true);
  }
  requestUrl = requestUrl.split("?")[0]
  const isExists = formDataUrls.includes(requestUrl);
  if (isExists) {
    contentType = CONTENT_TYPES?.MULTIPART_FORM_DATA;
  }
  return contentType;
};

const stringToSearch = (stringToSplit, separator, isQueryString = false) => {
  const arrayOfStrings = stringToSplit.split(separator);
  if (!isQueryString) {
    const lastString = arrayOfStrings[arrayOfStrings.length - 1];
    return `${separator}${lastString}`;
  }
  return arrayOfStrings[0];
};

export const getErrorMessage = (error, message) => {
  return typeof error?.message === 'string' ? error?.message: message
}

export const getInvalidDateRangeError = (startDate, endDate) => {
  if (!isValid(startDate) || !isValid(endDate)) {
    return 'Please select valid dates';
  } else if (!isBefore(startDate, endDate)) {
    return 'Start date must be before end date';
  } else {
    return '';
  }
};



